export const environment = {
  production: true,
  urlEnvironmentService :  'https://eus-mc-envserv-dev-webapp.azurewebsites.net',
  urlIISResetService : 'https://eus-mc-iisreset-serv-dev-webapp.azurewebsites.net',
  urlTraceServices: 'https://eus-mc-traceserv-dev-webapp.azurewebsites.net',
  eventLogService: 'https://eus-mc-dev-webapp.azurewebsites.net'
};
